import { Injectable } from '@angular/core';
import { HistoryItemResponse } from './models/history-item.response';
import { HistoryItem } from './models/history-item.model';

@Injectable({
  providedIn: 'root',
})
export class HistoryFactory {
  buildHistoryItem(responseItem: HistoryItemResponse): HistoryItem {
    return {
      ...responseItem,
      loanStart: responseItem.loanStart ? new Date(responseItem.loanStart) : null,
      loanEnd: responseItem.loanEnd ? new Date(responseItem.loanEnd) : null,
      stats: {
        ...responseItem.stats,
        firstAccess: new Date(responseItem.stats.firstAccess),
        lastAccess: new Date(responseItem.stats.lastAccess),
      }
    };
  }
}
